import { useMemo } from 'react';

import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanManagedObjectsIds } from '@api/hitoryCheck';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_MO_IDS } from '@constants/queryKeys';

interface IUseQueryHistoryCheckAwtgRanMoIdsParams {
	dumpHistoryId: string;
	dataModelPathId: string;
	moName: string;
	isAwtgRanVendor?: boolean;
}

interface IUseQueryHistoryCheckAwtgRanMoIdsReturnValue {
	moIds: string[];
	moIdsOptions: TSelectOption<string>[];
	isLoadingMoIds: boolean;
}

export const useQueryHistoryCheckAwtgRanMoIds = ({
	dumpHistoryId,
	dataModelPathId,
	moName,
	isAwtgRanVendor,
}: IUseQueryHistoryCheckAwtgRanMoIdsParams): IUseQueryHistoryCheckAwtgRanMoIdsReturnValue => {
	const {
		data: moIds = [],
		isLoading: isLoadingMoIds,
	} = useQuery<string[]>({
		queryFn: () => getHistoryCheckAwtgRanManagedObjectsIds(dumpHistoryId, dataModelPathId, moName),
		queryKey: [HISTORY_CHECK_MO_IDS, 'awtg-ran', dumpHistoryId, dataModelPathId, moName],
		enabled: [!!(dumpHistoryId && dataModelPathId && isAwtgRanVendor)],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	const moIdsOptions = useMemo(
		() => moIds.map(id => ({ label: id, value: id })),
		[moIds],
	);

	return {
		moIds,
		moIdsOptions,
		isLoadingMoIds,
	};
};
